import { render, staticRenderFns } from "./Reminder.vue?vue&type=template&id=7bf31e66&"
import script from "./Reminder.vue?vue&type=script&lang=js&"
export * from "./Reminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports